import { reactive } from "@vue/composition-api"
import validate from "validate.js"

function useValidator(constraints) {
  let o = {}
  let e = {}
  for (var property in constraints) {
    o[property] = undefined
    e[property] = undefined
  }
  const model = reactive(o)
  const error = reactive(e)

  validate.validators.lengthOptional = function(value, options, key, attributes) {
    if (value) {
      return validate.validators.length(value, options, key, attributes)
    }
    return ''
  }

  const validateEvent = (e) => {
    const { srcElement } = e
    const { id, value } = srcElement
    return validateProperty(id, value)
  }

  const validateProperty = (id, value) => {
    let data = {}
    data[id] = value
    const result = validate(data, constraints)
    model[id] = result && result[id] ? false : true // 'is-invalid' : 'is-valid'
    error[id] = result && result[id] ? result[id].join(', ') : ''
    return !(result && result[id])
  }

  const validateAll = (data) => {
    const result = validate(data, constraints)
    let isValid = true;
    for (property in data) {
      model[property] = result && result[property] ? false : true // 'is-invalid' : 'is-valid'
      error[property] = result && result[property] ? result[property].join(', ') : ''
      isValid &= !(result && result[property])
    }
    return isValid
  }

  return {
    model,
    error,
    validateEvent,
    validateProperty,
    validateAll
  }
}

export { useValidator }